module.exports = __webpack_public_path__ + "img/7f008db95d06c8dbe2f82d0b385b50b2.2102edce.jpg";